<template>
    <NavbarMain/>

    <PresentationSection :photo="first_section_image_en" :title="first_section_title_en" :content="first_section_content_en"/>

    <CardSection :content-title="second_section_title_en" :content-sentance="second_section_content_en" :button-text="second_section_link_content_en" :button-link="second_section_link_en"/>

    <!-- Photo gallery comes from the EN record (photos[]) -->
    <PhotoGallery :photos="photos" />

    <WidePhotoComponent :photo="fourth_section_image_en" :content="fourth_section_content_en" />

    <FooterPage/>
</template>

<script>
import axios from 'axios';
import CardSection from '@/components/CardSection.vue';
import FooterPage from '@/components/FooterPage.vue';
import NavbarMain from '@/components/NavbarMain.vue';
import PhotoGallery from '@/components/PhotoGallery.vue';
import PresentationSection from '@/components/PresentationSection.vue';
import WidePhotoComponent from '@/components/WidePhotoComponent.vue';

export default {
    components: {
        NavbarMain,
        PhotoGallery,
        PresentationSection,
        FooterPage,
        WidePhotoComponent,
        CardSection
    },
    data() {
        return {
            aboutProjectData: { items_en: [{}] },
            photos: [],
            first_section_title_en: '',
            first_section_content_en: '',
            first_section_image_en: '',
            second_section_title_en: '',
            second_section_content_en: '',
            second_section_link_en: '',
            second_section_link_content_en: '',
            third_section_image_en: '',
            third_section_title_en: '',
            third_section_content_en: '',
            fourth_section_image_en: '',
            fourth_section_content_en: '',
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/about-project-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.aboutProjectData = response.data || { items_en: [] };

                // Gallery photos live on the EN record; the gallery sorts/filters them.
                this.photos = this.aboutProjectData.items_en[0]?.photos || [];

                if (this.aboutProjectData.items_en[0]?.active === true) {
                    this.first_section_title_en = this.aboutProjectData.items_en[0].first_section_title;
                    this.first_section_content_en = this.aboutProjectData.items_en[0].first_section_content;
                    this.first_section_image_en = this.aboutProjectData.items_en[0].first_section_image;
                    this.second_section_title_en = this.aboutProjectData.items_en[0].second_section_title;
                    this.second_section_content_en = this.aboutProjectData.items_en[0].second_section_content;
                    this.second_section_link_en = this.aboutProjectData.items_en[0].second_section_link;
                    this.second_section_link_content_en = this.aboutProjectData.items_en[0].second_section_link_content;
                    this.third_section_image_en = this.aboutProjectData.items_en[0].third_section_image;
                    this.third_section_title_en = this.aboutProjectData.items_en[0].third_section_title;
                    this.third_section_content_en = this.aboutProjectData.items_en[0].third_section_content;
                    this.fourth_section_image_en = this.aboutProjectData.items_en[0].forth_section_image;
                    this.fourth_section_content_en = this.aboutProjectData.items_en[0].forth_section_content;
                }
            })
            .catch(error => {
                console.error('Error fetching About Project data:', error);
            });
    }
}
</script>

<style>
</style>
